import { useQuery } from '@tanstack/react-query';

import { FinCENApi } from 'api';
import { FINCEN_EXPORT_RECORD_SUBMISSION_METADATA_KEY } from 'hooks/keys';
import { useUser } from 'hooks/queries';

export function useExportRecordAutofileSubmissionMetadata(exportRecordId: string) {
  const { userBankId } = useUser();
  const fincenApi = new FinCENApi();

  const {
    data: fincenExportRecordSubmissionMetadata,
    isLoading: isLoadingFincenExportRecordSubmissionMetadata,
    isError: isFincenExportRecordSubmissionMetadataError
  } = useQuery({
    enabled: !!userBankId.length && !!exportRecordId.length,
    queryKey: [FINCEN_EXPORT_RECORD_SUBMISSION_METADATA_KEY, userBankId, exportRecordId],
    queryFn: () => fincenApi.getExportRecordAutofileSubmissionMetadata(userBankId, exportRecordId),
    meta: {
      snackbarErrorMessage:
        'There was an issue loading the FinCEN export record. Please contact support if the problem persists.'
    }
  });

  const { exportRecord, submissions, fincen_reports } = fincenExportRecordSubmissionMetadata ?? {};

  return {
    exportRecord,
    submissions,
    fincen_reports,
    isLoadingFincenExportRecordSubmissionMetadata,
    isFincenExportRecordSubmissionMetadataError
  };
}
